import { IntegrationStatus } from '@features/bills/types/integrationStatus'

export const getLatestIntegrationStatus = (statuses?: IntegrationStatus[]): IntegrationStatus | undefined => {
  if (!statuses || !statuses.length) {
    return undefined
  }

  const latestStatus = statuses?.reduce((latest, current) => {
    const latestTimestamp = Date.parse(latest.statusSetAt)
    const currentTimestamp = Date.parse(current.statusSetAt)

    return currentTimestamp > latestTimestamp ? current : latest
  })

  return latestStatus
}
